import { Component, Input } from '@angular/core';

import { MasterDataService } from '../../services/master-data.service';
import { ApiCallCachingService } from '../../services/api-call-caching.service';

import { DropdownBaseComponent } from './dropdown-base/dropdown-base.component';
import { JurisdictionObligationOption } from '../../models/master-data/jurisdiction-obligation-option.model';

@Component({
    selector: 'spv2-jurisdiction-obligation-by-company-dropdown',
    templateUrl: './dropdown-base/dropdown-base.component.html',
    styleUrls: ['./dropdown-base/dropdown-base.component.scss'],
    standalone: false
})
export class JurisdictionObligationByCompanyDropdownComponent extends DropdownBaseComponent<string, JurisdictionObligationOption> {
  
  private _companyId : string;
  @Input() public set companyId(v : string) {
    this._companyId = v;
    if(this.value) {
      this.value = null;
      this.valueChange.emit(this.value);
    }
    this.debounceTrigger.execute(null);
  }

  get uniqueName() {
    return "jurisdictionObligations" +  this._companyId;
  } 

  textField = "name";
  valueField = "code";

  enableCache = false;
  loadDataAutomatically = false;

  dataFunction = (filter : string) => {
    if(this._companyId) return this.masterDataService.getSimpleJurisdictionObligationListByCompanyId(filter, this._companyId);
  }

  constructor(private masterDataService: MasterDataService, cachingService: ApiCallCachingService) {
    super(cachingService);
  }
}
